module.exports = __webpack_public_path__ + "static/media/armbeygja_small.1a90e6b2.png";